import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductsState } from '../reducer/products.reducer';

export const selectProductsState = createFeatureSelector<ProductsState>('products');

export const selectProductsLoadingState = createSelector(selectProductsState, (state) => state.loading);

export const selectProductsError = createSelector(selectProductsState, (state) => state.error);

export const selectProductsSuccessState = createSelector(selectProductsState, (state) => state.success);
